export default __webpack_public_path__ + "static/media/astra-motor.1e4908e2.svg";